// extracted by mini-css-extract-plugin
export default {"loader_slide":"Loader_loader_slide__2nh0d","svg":"Loader_svg__AANVQ","circle":"Loader_circle__cG308","loader":"Loader_loader__j0Tkq","load":"Loader_load__FZcOF"};